'use client';

import { useRef, useState } from 'react';

import classnames from 'classnames';
import { IoClose } from 'react-icons/io5';
import { Transition } from 'react-transition-group';

import type { ToastProps } from './Toast.types';

import styles from './Toast.module.scss';

function Toast({
  style,
  className,
  message,
  annotation,
  variant,
  onClose,
  onClick = () => {},
  testId = 'ui-toast',
}: ToastProps) {
  const [animate, setAnimate] = useState(true);

  const nodeRef = useRef(null);

  return (
    <Transition
      in={animate}
      appear={true}
      unmountOnExit={true}
      timeout={{
        appear: 500,
        enter: 300,
        exit: 200,
      }}
      onExited={onClose}
      nodeRef={nodeRef}
    >
      {(state) => (
        <div
          ref={nodeRef}
          style={style}
          className={classnames(
            styles['toast'],
            state && styles[`toast--${state}`],
            className,
          )}
          onClick={() => {
            onClick();
            setAnimate(false);
          }}
          data-testid={testId}
        >
          <div className={styles['header']}>
            <strong
              className={classnames(
                styles['title'],
                variant && styles[`title--${variant}`],
              )}
              data-testid={`${testId}_title`}
            >
              {message.title}
            </strong>
            <div className={styles['corner']}>
              {annotation && (
                <span
                  className={styles['annotation']}
                  data-testid={`${testId}_annotation`}
                >
                  {annotation}
                </span>
              )}
              <div className={styles['icon-wrapper']}>
                <IoClose
                  className={styles['icon']}
                  aria-label="close"
                  onClick={() => {
                    setAnimate(false);
                  }}
                  data-testid={`${testId}_close-btn`}
                />
              </div>
            </div>
          </div>
          <div className={styles['body']} data-testid={`${testId}_message`}>
            {message.text}
          </div>
        </div>
      )}
    </Transition>
  );
}

export { Toast };
